const $ = require('jquery');
const { $window } = require('../lib/selectors');
const throttle = require('lodash.throttle');
const forEach = require('lodash.foreach');

const imgChangeWidth = 800;
const $hero = $('.js-bg');
// set to null on init
let lastSize = null;

setCorrectImage();
$window.on('resize', throttle(setCorrectImage, 250));

function setCorrectImage() {
  forEach($hero, value => {
    const smImg = value.dataset.bgsmall;
    const lgImg = value.dataset.bglarge;
    // only triggers new background if changing sizes
    if (window.innerWidth < imgChangeWidth && (lastSize > imgChangeWidth || lastSize === null)) {
      $(value).css('background-image', `url(${smImg})`);
      // console.log('hit small');
      // checkLoad($(value), smImg);
    } else if (window.innerWidth >= imgChangeWidth && (lastSize <= imgChangeWidth || lastSize === null)) {
      $(value).css('background-image', `url(${lgImg})`);
      // console.log('hit large');
      // checkLoad($(value), lgImg);
    }
    // checkLoad();
  });
  lastSize = window.innerWidth;
}

function checkLoad($item, imgURL) {
  const $img = $('<img/>').attr('src', imgURL);
  if ($img[0].loaded) {
    handleLoad($item);
  } else {
    $img[0].addEventListener('load', () => {
      handleLoad($item);
    });
  }
}

function handleLoad($item) {
  // if the hero has text/log inside of it
  // fade those in after the image loads
  if ($item.siblings('.hero__inner').length) {
    const $innerHero = $item.siblings('.hero__inner').children();
    TweenMax.to($item, 0.5, {
      opacity: 1,
    });
    TweenMax.to($innerHero, 0.5, {
      y: 0,
      opacity: 1,
      delay: 0.3,
    });
  } else {
    TweenMax.to($item, 0.5, {
      opacity: 1,
    });
  }
}
